import { Link } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import Header from "../../components/navbar/Header";
import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import DrivingSchoolWhyChoose from "./DrivingSchoolWhyChoose";
import DrivingSchoolCourses from "./DrivingSchoolCourses";
import CustomSlider from "../../components/CustomSlider";
import drivingBanner from "../../assets/mobile-banners/Gem_Web_Banners_MDS.webp";
const servicemobileSlides = [
  {
    img: drivingBanner,
    alt: "service",
  },

];
const DrivingSchool = () => {
  const [phone, setPhone] = useState("");
  const [, setEmail] = useState("");
  const [, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [, setOutlet] = useState("");

  const pattern = /^[6-9][0-9]{6,9}$/;
  if (phone !== "" && phone.length === 10 && !pattern.test(phone)) {
  }

  function handleSubmit(e) {
    setLoading(false);
  }

  return (
    <div>
      <Header />
      <div className="hidden md:block">
        <img
          src={require("../../assets/banners/Banners_MDS.webp")}
          loading="lazy"
          className="w-full lg:h-[550px] object-cover"
          alt="inusrance banner"
        /></div>
      <CustomSlider
        slides={servicemobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="px-4 shadow sm:px-0">
        <p className="container py-4 mx-auto">
          <Link to="/">Home</Link> / Driving School
        </p>
      </div>

      <div className="container p-5 px-5 mx-auto my-10 rounded-lg">
        <DrivingSchoolWhyChoose />
        <DrivingSchoolCourses />
        <p className="text-2xl font-semibold text-red-500">
          Please contact us for Driving School Enquiries
        </p>
        <form onSubmit={handleSubmit} className="mt-6 space-y-6">
          {/* GRID FIELDS */}
          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            {/* NAME */}
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-medium text-gray-700">
                Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                required
                onChange={(e) => setName(e.target.value)}
                className="w-full px-4 py-3 text-sm text-gray-700 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-red-400 focus:outline-none"
              />
            </div>

            {/* EMAIL */}
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="email"
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 text-sm text-gray-700 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-red-400 focus:outline-none"
              />
            </div>

            {/* PHONE */}
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-medium text-gray-700">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                maxLength="10"
                minLength="10"
                required
                value={phone}
                onChange={(e) =>
                  setPhone(e.target.value.replace(/[^0-9]/g, ""))
                }
                className="w-full px-4 py-3 text-sm text-gray-700 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-red-400 focus:outline-none"
              />

              {phone.length === 10 && !pattern.test(phone) && (
                <p className="mt-1 text-xs text-red-500">
                  Phone number is invalid
                </p>
              )}
            </div>

            {/* OUTLET */}
            <div className="flex flex-col">
              <label className="mb-2 text-sm font-medium text-gray-700">
                Select Outlet <span className="text-red-500">*</span>
              </label>

              <select
                required
                onChange={(e) => setOutlet(e.target.value)}
                className="w-full px-4 py-3 text-sm text-gray-700 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-red-400 focus:outline-none"
              >
                <option value="">-- Select Outlet --</option>
                <option value="Moosapet">Moosapet</option>
                <option value="Suncity">Suncity</option>
                <option value="Madhapur">Madhapur</option>
                <option value="Kondapur">Kondapur</option>
                <option value="Manikonda">Manikonda</option>
                <option value="Hydernagar">Hydernagar</option>
              </select>
            </div>
          </div>

          {/* DISCLAIMER TEXT */}
          <p className="text-sm leading-relaxed text-gray-700">
            <span className="font-semibold text-black">Disclaimer:</span>I agree
            that by clicking the ‘Submit’ button below, I am explicitly
            soliciting a call / message from Gem Motor Pvt. Ltd or its
            Representatives on my mobile.
          </p>

          {/* DISCLAIMER CHECKBOX */}
          <div className="flex items-start gap-2">
            <input
              id="disclaimer"
              name="disclaimer"
              type="checkbox"
              required
              className="w-4 h-4 text-red-600 border-gray-300 rounded focus:ring-red-400"
            />
            <label htmlFor="disclaimer" className="text-sm text-gray-700">
              Please agree with the above disclaimer.
            </label>
          </div>

          {/* SUBMIT BUTTON */}
          <button
            type="submit"
            disabled={!pattern.test(phone) || phone.length !== 10}
            className={`w-full md:w-auto px-8 py-3 text-white rounded-lg text-sm font-semibold
                transition-all flex items-center justify-center
                ${!pattern.test(phone) || phone.length !== 10
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-red-600 hover:bg-[#253E72]"
              }`}
          >
            {loading ? (
              <div className="flex items-center gap-2">
                <CgSpinner className="w-5 h-5 animate-spin" />
                Loading...
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>
      </div>
      <Footer />
    </div>
  );
};

export default DrivingSchool;
